import { isSessionFirstBarV2 } from './isSessionFirstBar';
/**
 * 計算日內特定數列最大值
 *
 * @param this
 * @param series 數列
 * @param sessionType 交易時段
 * @returns Number
 */
export function intradayHighest(series, sessionType) {
    const intradayCurrentBar = this.intradayCurrentBar(sessionType);
    return this.highest(series, intradayCurrentBar);
}
export function intradayHighestV2(hh, tt, sessionType) {
    for (let i = 0; i < Math.min(hh.mindepth, tt.mindepth); i++) {
        if (isSessionFirstBarV2(tt.get(i), tt.get(i + 1), this._context.symbol.period, sessionType)) {
            return this.PineJS.Std.highest(hh, i + 1, this._context);
        }
    }
    return NaN;
}
